module.exports = __webpack_public_path__ + "media/images/logos/privoz-f1614b412a8407a3df2167e9d6987035.png";